<template>
  <div class="zl_rate" v-show="isover">
    <div class="zl_rate_item" v-for="( t, i ) in rateList" :key="i" :class="'tare'+ i">
      <el-rate
        v-model="rateList[i]"
        disabled
        :max="1"
        :text-color="color"
        score-template="{value}">
      </el-rate>
    </div>
  </div>
</template>

<script>
  export default {
    name: "zl_rate",
    data() {
      return {
        rateList: [],
        isover: false,
        timer: null,
      }
    },
    props: {
      value: {
        type: Number,
        default: 0,
      },
      color: {
        type: String,
        default: '#ff9900'
      },
      refresh: {
        type: Boolean,
        default: false
      },
    },
    watch: {
      refresh: {
        handler() {
          if (!this.isover && this.value) {
            if (this.value > 5) return
            this.rateList = [];
            this.isover = true;
            this.init();
          }
        },
        immediate: true,
        deep: true,
      },
    },
    created() {
      this.init();
    },
    mounted() {

    },
    beforeDestroy() {
      clearTimeout(this.timer)
    },
    methods: {
      init() {
        for (let i = 0; i < parseInt(this.value); i++) {
          this.rateList.push(1)
        }
        if (this.value % 1) {
          this.rateList.push(Number((this.value % 1).toFixed(2)))
        }

        if (this.value && this.rateList.length < 5) {
          let num = 5 - this.rateList.length
          for (let i = 0; i < num; i++) {
            this.rateList.push(0)
          }
        }
        // console.log('--score-分数:', this.value, this.rateList);
        let that = this;
        that.timer = setTimeout(() => {
          that.isover = false;
        }, 6000)
      }
    }
  }
</script>
<style lang='scss' scoped>
  .zl_rate {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20000;

    .zl_rate_item {
      width: 0px;
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }

    .tare0 {
      animation: tare0 0s ease-in 1s forwards;
    }

    @keyframes tare0 {
      to {
        width: 120px;
        overflow: initial;
      }
    }

    .tare1 {
      animation: tare1 0s ease-in 1.6s forwards;
    }

    @keyframes tare1 {
      to {
        width: 120px;
        overflow: initial;
      }
    }

    .tare2 {
      animation: tare2 0s ease-in 2.2s forwards;
    }

    @keyframes tare2 {
      to {
        width: 120px;
        overflow: initial;
      }
    }

    .tare3 {
      animation: tare3 0s ease-in 2.8s forwards;
    }

    @keyframes tare3 {
      to {
        width: 120px;
        overflow: initial;
      }
    }

    .tare4 {
      animation: tare4 0s ease-in 3.4s forwards;
    }

    @keyframes tare4 {
      to {
        width: 120px;
        overflow: initial;
      }
    }


    /deep/ .el-rate {
      height: auto;
      line-height: initial;

      .el-rate__icon,
      .el-rate__decimal,
      .el-icon-star-on {
        font-size: 100px;
        animation-name: change;
        animation-delay: 3.4s;
        animation-duration: 1s;
        animation-timing-function: ease;
        /*animation-iteration-count: infinite;*/
        /*animation-play-state: running;*/
      }
    }

    @keyframes change {
      0% {
        font-size: 100px;
      }
      35% {
        font-size: 130px;
      }
      70% {
        font-size: 100px;
      }
      85% {
        font-size: 110px;
      }
      100% {
        font-size: 100px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/component/zl_rate.vue